
// export type langTypes = 'pl' |'en' |'de' | 'fr' |'hu' | 'it' |'lt'  |'ro' |'ru'

export const passively_maintained_languages_list = ['es', 'fr', 'it'] as const;

export const passively_maintained_languages = {
  es: 'es',
  fr: 'fr',
  it: 'it',
} as const;


export const langs = {
  pl: 'pl',
  en: 'en',
  de: 'de',
  hu: 'hu',
  lt: 'lt',
  ro: 'ro',
  ru: 'ru',
  ua: 'ua',
  uk: 'uk',
  ...passively_maintained_languages
} as const;

export const newsletter_languages = [
  'pl', 'en', 'de', 'ua', 'lt', 'ru', ...passively_maintained_languages_list
] as const;

const DISABLED_LANGS_IN_DROPDOWN: string[] = [
  //'fr'
];

const langNames = {
  pl: 'Polski',
  en: 'English',
  es: 'Español',
  de: 'Deutsch',
  fr: 'Français',
  hu: 'Magyar',
  it: 'Italiano',
  lt: 'Lietuvių',
  ro: 'Română',
  ru: 'Русский',
  ua: 'Українська',
};

export enum flag {
  pl = 'pl',
  en = 'gb',
  es = 'es',
  de = 'de',
  fr = 'fr',
  hu = 'hu',
  it = 'it',
  lt = 'lt',
  ro = 'ro',
  ru = 'ru',
  ua = 'ua',
}

export enum locales {
  pl = 'pl_PL',
  en = 'en_GB',
  es = 'es_ES',
  de = 'de_DE',
  fr = 'fr_FR',
  hu = 'hu_HU',
  it = 'it_IT',
  lt = 'lt_LT',
  ro = 'ro_RO',
  ru = 'ru_RU',
  ua = 'uk_UA',
}
export const all_languages = Object.keys(langNames) as Array<keyof typeof langNames>;

export const languageNames = Object.fromEntries(
  Object.entries(langNames).filter(([key]) => !DISABLED_LANGS_IN_DROPDOWN.includes(key))
) as typeof langNames;

export type langDropdownTypes = keyof typeof languageNames;

export const languageNameCodes = Object.keys(languageNames) as langDropdownTypes[];
export type Language = typeof langs[keyof typeof langs];

export type localeTypes = typeof locales[keyof typeof locales];

const localeList = ['en_GB', 'pl_PL', 'es_ES', 'de_DE', 'fr_FR', 'hu_HU', 'it_IT', 'lt_LT', 'ro_RO', 'ru_RU', 'uk_UA'] as const
const localeListLowercase = ['en_gb', 'pl_pl', 'es_es', 'de_de', 'fr_fr', 'hu_hu', 'it_it', 'lt_lt', 'ro_ro', 'ru_ru', 'uk_ua'] as const
export type localeListTypes = typeof localeList[number];
export type localeListLowercaseTypes = typeof localeListLowercase[number];
